export default __webpack_public_path__ + "static/exemption-icon-60d702a5a19bab50acee1cbfdccb7e49.svg";